import { render, staticRenderFns } from "./aprflow.vue?vue&type=template&id=b4a3ca2c&scoped=true&lang=pug&"
import script from "./aprflow.vue?vue&type=script&lang=js&"
export * from "./aprflow.vue?vue&type=script&lang=js&"
import style0 from "./aprflow.vue?vue&type=style&index=0&id=b4a3ca2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a3ca2c",
  null
  
)

export default component.exports